const ProgressBar = {
  contentWrapper: null,
  inputTypeText: null,
  containerContent: null,
  progressLineSelector: '.progress_line .inner',
  progressValueSelector: '.status_completing .value',
  progressTimeLeftSelector: '.time_to_finish',
  progressTimeExplanationSelector: '.time_explanation',

  timeEstimate: '<div class="time_estimate sticky-time-estimate">' +
    '<p class="time_line"><span class="time_to_finish"></span><span class="time_explanation"></p>' +
    '<div class="progress_bar">' +
    '<div class="progress_line">' +
    '<div class="inner"></div> ' +
    '</div>' +
    '<p class="status_completing">' +
    '<span class="value">0</span>' + ' % Complete' +
    '</p>' +
    '<div class="arrow_0"></div>' +
    '<div class="arrow_1"></div>' +
    '<div class="arrow_2"></div>' +
    '<div class="arrow_3"></div>' +
    '</div>' +
    '</div>',
};


ProgressBar.init = () => {
  $('body').addClass('h-prog');

  ProgressBar.contentWrapper = $('#srb_content_wrapper');
  ProgressBar.inputTypeText = ProgressBar.contentWrapper.find('input[type="text"]');
  ProgressBar.containerContent = $('.builder-toolbar .container');

  ProgressBar.containerContent.append(ProgressBar.timeEstimate);

  ProgressBar.handleEvent();
  ProgressBar.handleCompletionTime();
  ProgressBar.handleStickiness();
};

ProgressBar.setValues = (counter, elemVal, cssElem) => {
  if (counter === 0) {
    elemVal.text('20');
    cssElem.css({
      width: '22%',
    });
  } else if (counter > 0 && counter <= 4) {
    elemVal.text('40');
    cssElem.css({
      width: '42%',
    });
  } else if (counter >= 5 && counter <= 9) {
    elemVal.text('60');
    cssElem.css({
      width: '62%',
    });
  } else if (counter >= 10 && counter <= 14) {
    elemVal.text('80');
    cssElem.css({
      width: '82%',
    });
  } else if (counter >= 15) {
    elemVal.text('100');
    cssElem.css({
      width: '100%',
    });
  }
};

ProgressBar.handleEvent = function() {
  let counter = 0;
  const value = $(ProgressBar.progressValueSelector);
  const progressLine = $(ProgressBar.progressLineSelector);


  ProgressBar.inputTypeText.each(function() {
    if ($(this).val().length) {
      counter += 1;
    }
  });

  ProgressBar.setValues(counter, value, progressLine);
};

ProgressBar.handleCompletionTime = function() {
  const changeLimelineText = (filledInputCount) => {
    $(ProgressBar.progressTimeExplanationSelector).text('Until Completion');

    if (filledInputCount === 0) {
      $(ProgressBar.progressTimeLeftSelector).text('2 min ');
      $(ProgressBar.progressValueSelector).text('20');
    } else if (filledInputCount > 0 && filledInputCount < 5) {
      $(ProgressBar.progressTimeLeftSelector).text('1 Min 30 Sec ');
    } else if (filledInputCount >= 5 && filledInputCount < 10) {
      $(ProgressBar.progressTimeLeftSelector).text('1 Min ');
    } else if (filledInputCount >= 10 && filledInputCount < 15) {
      $(ProgressBar.progressTimeLeftSelector).text('30 Sec ');
    } else {
      $(ProgressBar.progressTimeLeftSelector).text('You’re Done! ');
      $(ProgressBar.progressTimeExplanationSelector).text(' ');
    }
  };

  const countFilledInputs = () => {
    let currentNumber = 0;

    $.each($('input[type="text"]'), function () {
      if ($(this).val().length) currentNumber += 1;
    });

    return currentNumber;
  };

  const updateCompletionTime = () => {
    const numberFilledInputs = countFilledInputs();
    changeLimelineText(numberFilledInputs);
  };

  updateCompletionTime();

  $('body').on('change', 'input[type="text"]', updateCompletionTime);
};

ProgressBar.handleStickiness = function () {
  const timeEstimateToolbarTop = $('.sticky-time-estimate-toolbar').offset().top;

  $(window).scroll(function () {
    if ($(window).scrollTop() >= timeEstimateToolbarTop) {
      $('.sticky-time-estimate-toolbar').addClass('fixed');
    } else {
      $('.sticky-time-estimate-toolbar').removeClass('fixed');
    }
  });
};

module.exports = ProgressBar;



// WEBPACK FOOTER //
// ./src-assets/js/progress-bar.js